<template>
  <div class="form-container">
    <h3>{{ $t("_info_simulateur_") }}</h3>
    <v-card outlined class="pa-4">
      <h3 class="green--text mb-3">1. {{ $t("_donnees_d_entrees_") }}</h3>

      <table class="input-table">
        <tr>
          <td class="label">{{ $t("_site_") }}</td>
          <td>
            <v-select
              dense
              outlined
              hide-details
              :items="siteItems"
              item-text="name"
              item-value="id"
              v-model="form.installationId"
            />
          </td>
        </tr>

        <tr>
          <td class="label">{{ $t("_type_de_site_") }}</td>
          <td>
            <v-text-field dense outlined hide-details v-model="form.siteType" />
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t("_puissance_crete_(kwc)_") }}</td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              suffix="kWc"
              v-model.number="form.power"
            />
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t("_prix_du_mwh_") }}</td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              suffix="€/MWh"
              v-model.number="form.priceMwh"
            />
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t("_cout_nettoyage_") }}</td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              suffix="€/m²"
              v-model.number="form.cleaningCost"
            />
          </td>
          <td class="comment">
            {{ $t("_description_cout_nettoyage_") }}
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t("_cout_nettoyage_valeur_forcee_") }}</td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              suffix="€/m²"
              v-model.number="form.forcedCleaningCost"
            />
          </td>
          <td class="comment">
            {{ $t("_description_cout_nettoyage_valeur_forcee_") }}
          </td>
        </tr>
        <tr>
          <td class="label">{{ $t("_superficie_installation_") }}</td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              suffix="m²"
              v-model.number="form.surface"
            />
          </td>
          <td class="comment">
            {{ $t("_description_superficie_installation_") }}
          </td>
        </tr>
        <tr>
          <td class="label">
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
              >
                <span v-bind="tooltipAttrs" v-on="tooltipOn">
                  {{ $t("_gain_factor_") }}
                </span>
              </template>
              <span>{{ $t("_description_gain_factor_hover_") }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-text-field
              dense
              outlined
              hide-details
              v-model.number="form.gainFactor"
            />
          </td>
        </tr>
      </table>
      <v-spacer></v-spacer>
      <div class="btn-simulateur">
        <v-btn
          :disabled="!isFormValid"
          :loading="submitting"
          @click="submitSimulation"
        >
          {{ $t("_submit_") }}
        </v-btn>
      </div>
    </v-card>
    <v-card outlined class="pa-4 mt-4">
      <h3 class="green--text">2. {{ $t("_resultats_") }}</h3>

      <v-simple-table class="input-table" dense>
        <tbody>
          <tr>
            <td class="label">{{ $t("_frequence_de_nettoyage_") }}</td>
            <td>{{ results.frequency }}</td>
          </tr>

          <tr>
            <td class="label">{{ $t("_pertes_encrassement_") }}</td>
            <td>{{ results.loss }}</td>
          </tr>

          <tr>
            <td class="label">{{ $t("_cout_annuel_") }}</td>
            <td>{{ results.annualCost }}</td>
          </tr>

          <tr>
            <td class="label">{{ $t("_reference_") }}</td>
            <td>{{ results.reference }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <v-card outlined class="mt-4">
      <v-simple-table dense>
        <thead>
          <tr>
            <th></th>
            <th>{{ $t("_pertes_vs_scenario_") }}</th>
            <th>{{ $t("_pertes_encrassement_moyenne_") }}</th>
            <th>{{ $t("_cout_annuel_") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in scenarios" :key="item.frequency">
            <td class="frequency-cell">{{ item.frequency }}</td>
            <td>{{ item.loss }}</td>
            <td>{{ item.percent }}</td>
            <td>{{ item.cost }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-spacer></v-spacer>
      <div class="btn-simulateur">
        <v-btn>
          {{ $t("_download_results_") }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import api from "@/api/api";

export default {
  props: {
    installationIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        installationId: null,
        siteType: "",
        power: null,
        priceMwh: null,
        cleaningCost: null,
        forcedCleaningCost: null,
        surface: null,
        gainFactor: 90,
      },
      siteTypes: ["Toiture", "Ombrière", "Sol"],
      environments: ["Périurbain", "Urbain", "Agricole", "Industriel"],
      scenarios: [
        { frequency: "6M", loss: "", percent: "", cost: "" },
        { frequency: "12M", loss: "", percent: "", cost: "" },
        { frequency: "24M", loss: "", percent: "", cost: "" },
        { frequency: "36M", loss: "", percent: "", cost: "" },
        { frequency: "48M", loss: "", percent: "", cost: "" },
        { frequency: "60M", loss: "", percent: "", cost: "" },
        {
          frequency: this.$t("_pas_de_nettoyage_"),
          loss: "",
          percent: "",
          cost: "",
        },
      ],
      results: {
        frequency: "",
        loss: "",
        annualCost: "",
        reference: "",
      },
    };
  },

  watch: {
    async "form.installationId"(installationId) {
      const installation = this.installations.find(
        (i) => Number(i.installation_id) === Number(installationId)
      );

      if (!installation) {
        this.form.siteType = "";
        this.form.power = null;
        this.form.priceMwh = null;
        this.form.surface = null;
        return;
      }
      this.form.priceMwh = installation.kwh_price*1000;
      //this.form.cleaningCost = installation
      this.form.surface = Math.round(installation.ei_stc);
      this.form.power = installation.installed_power_kwc;
      this.form.siteType = this.getSiteType(installation.installation_type);
      this.form.cleaningCost = await this.getSuggestedCost(
      this.form.siteType
    );  
    },
  },

  computed: {
    ...mapGetters({
      cur_install_id: "cur_install_id",
      installations: "installations",
      role: "role",
    }),

    filteredInstallations() {
      return this.installations.filter((installation) =>
        this.installationIds.includes(installation.installation_id)
      );
    },

    siteItems() {
      return this.installations
        .filter((i) =>
          this.installationIds.some(
            (id) => Number(id) === Number(i.installation_id)
          )
        )
        .map((i) => ({
          id: i.installation_id,
          name: i.installation_name,
        }));
    },

    selectedSite() {
      return this.siteItems.find(
        (s) => Number(s.id) === Number(this.form.installationId)
      );
    },

    isFormValid() {
      return (
        this.form.installationId != null &&
        this.form.siteType &&
        this.form.power != null &&
        this.form.priceMwh != null &&
        this.form.cleaningCost != null &&
        this.form.surface != null &&
        this.form.gainFactor != null
      );
    },
  },

  methods: {
    ...mapMutations(["SET_CUR_INSTALL_ID"]),

    getSiteType(installationType) {
      if (!installationType) return "";

      const type = installationType.toLowerCase();

      if (type.includes("toiture")) {
        return "Toiture";
      }

      if (type.includes("ombrière")) {
        return "Ombrière";
      }

      if (type.includes("sol")) {
        return "Sol";
      }

      return "";
    },
    async getSuggestedCost(installationType) {
      if (!installationType || !this.form.installationId) {
        return null;
      }

      try {
        const response = await api.getRefCleaninCost();

        const installation = response.data.find(
          (item) =>
            Number(item.installation_id) === Number(this.form.installationId)
        );

        if (
          !installation ||
          !installation.cleaning_cost_ref ||
          Array.isArray(installation.cleaning_cost_ref)
        ) {
          return null;
        }

        const type = installationType.toLowerCase();

        if (type.includes("toiture")) {
          return installation.cleaning_cost_ref.toiture;
        }

        if (type.includes("ombrière")) {
          return installation.cleaning_cost_ref.ombriere;
        }

        if (type.includes("sol")) {
          return installation.cleaning_cost_ref.centrale_au_sol;
        }

        if (type.includes("serre")) {
          return installation.cleaning_cost_ref.serre;
        }

        return null;
      } catch (error) {
        console.error("Unable to get suggested cleaning cost:", error);
        return null;
      }
    },

    async submitSimulation() {
      if (!this.isFormValid) return;
      this.results = null;
      this.scenarios = [];
      this.submitting = true;
      try {
        const payload = {
          installation_id: this.form.installationId,
          reference: this.selectedSite ? this.selectedSite.name : "",
          site_type: this.form.siteType,
          peak_power_kwc: this.form.power,
          tariff_eur_mwh: this.form.priceMwh,
          cleaning_cost_estimated: this.form.cleaningCost,
          cleaning_cost_forced: this.form.forcedCleaningCost ?? this.form.cleaningCost,
          pv_area_m2: this.form.surface,
          gain_factor: this.form.gainFactor,
        };

        const response = await api.postHelioSimulateur(payload);
        this.results = response.data;
        this.mapResponseToResults(this.results);
      } catch (error) {
        console.error("Simulation request failed:", error);
      } finally {
        this.submitting = false;
      }
    },

    mapResponseToResults(data) {
      const { optimal, comparison } = data;

      this.results = {
        frequency: optimal.frequency,
        loss: this.formatPercent(optimal.loss_fraction),
        annualCost: this.formatCurrency(optimal.annual_cleaning_cost),
        reference: optimal.reference,
      };

      const frequencyKeys = ["6M", "12M", "24M", "36M", "48M", "60M"];
      const scenarioRows = frequencyKeys.map((key) => {
        const item = comparison[key];
        return {
          frequency: key,
          loss: item ? this.formatCurrency(item.gain_difference) : "",
          percent: item ? this.formatPercent(item.loss_fraction) : "",
          cost: item ? this.formatCurrency(item.annual_cleaning_cost) : "",
        };
      });

      const noClean = comparison.no_clean;
      scenarioRows.push({
        frequency: this.$t("_pas_de_nettoyage_"),
        loss: noClean ? this.formatCurrency(noClean.gain_difference) : "",
        percent: noClean ? this.formatPercent(noClean.loss_fraction) : "",
        cost: noClean ? this.formatCurrency(noClean.annual_cleaning_cost) : "",
      });

      this.scenarios = scenarioRows;
    },

    formatPercent(value) {
      if (value == null) return "";
      return `${(value * 100).toFixed(2)} %`;
    },

    formatCurrency(value) {
      if (value == null) return "";
      return `${Math.round(value).toLocaleString("fr-FR")} €`;
    },
  },
};
</script>
<style scoped>
.input-table {
  width: 100%;
  border-collapse: collapse;
}

.input-table td {
  padding: 6px 10px;
  vertical-align: middle;
}

.input-table .label {
  width: 260px;
  font-weight: 600;
  background: #16a34a;
  color: white;
}

.input-table .comment {
  width: 320px;
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.frequency-cell {
  background: #16a34a;
  color: white;
  font-weight: 600;
  white-space: nowrap;
}
.btn-simulateur {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}
</style>
